import { module } from 'modujs';
import { Swiper, Navigation, Lazy, Parallax, Pagination, Autoplay } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Navigation, Lazy, Parallax, Pagination, Autoplay]);

        this.length = this.$('item').length
        this.container = this.$('container')[0];
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]
        this.pagination = this.$('pagination')[0]

        const args = {
            speed: 800,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1,
            threshold: 3,
            preloadImages: false,
            parallax: true,
            lazy: {
                loadPrevNext: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            pagination: {
                el: this.pagination,
                type: 'bullets',
                clickable: true
            }
        }

        if(this.length > 1) {


        } else {
            args.loop= false;
            args.simulateTouch= false;
            args.navigation= false;
            args.pagination= false;

            this.pagination.classList.add('u-visibility-hidden')
            this.arrowPrev.classList.add('u-visibility-hidden')
            this.arrowNext.classList.add('u-visibility-hidden')
        }

        this.carousel = new Swiper(this.container, args)
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
